import { ReactKeycloakProvider } from '@react-keycloak/web';
import withAxiosAuthorizationHeaderUpdater from './withAxiosAuthorizationHeaderUpdater.js';
import withMockProvider from './withMockProvider.js';
import withPageRefreshSupport from './withPageRefreshSupport/index.js';
export default withPageRefreshSupport(withAxiosAuthorizationHeaderUpdater(withMockProvider(ReactKeycloakProvider)));
//# sourceMappingURL=ReactKeycloakProvider.js.map